'use strict';

$ = jQuery;

var offerID = $('.jc-offer-header').data('id');
var context = $('.jc-offer-header').data('context');

form(offerID, context).then(function (leadID) {
  window.location.href += (window.location.href.indexOf("?") > -1 ? '&' : '?') + 'pagina=obrigado&id=' + leadID;
});